import React from 'react';

/** The supplied Lentic lockup artwork. */
export const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/rkUg1vBYDJdeiRNyrhAJx9/image.png';

/** Native aspect ratio of the lockup file. */
const RATIO = 2400 / 1150;
type LenticLogoProps = {
  /** Height of the mark in px; the lockup scales from it. */
  size?: number;
  className?: string;
};
export function LenticLogo({
  size = 36,
  className
}: LenticLogoProps) {
  const height = size * 1.15;
  return <img src={LOGO_SRC} alt="Lentic" width={Math.round(height * RATIO)} height={Math.round(height)} style={{
    height,
    width: 'auto'
  }} className={['block select-none mix-blend-multiply', className ?? ''].join(' ')} data-id="element-13" data-mp="2cu1ofddmnf3n" />;
}